import { Link } from 'react-router-dom';
import { FileText, Users, Building2 } from 'lucide-react';

const actions = [
  {
    name: 'Create Note',
    description: 'Start a new clinical note',
    icon: FileText,
    to: '/app/notes',
    color: 'blue',
  },
  {
    name: 'View Clients',
    description: 'Manage your clients',
    icon: Users,
    to: '/app/clients',
    color: 'green',
  },
  {
    name: 'Manage Offices',
    description: 'View your office locations',
    icon: Building2,
    to: '/app/offices',
    color: 'purple',
  },
];

export function QuickActions() {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return {
          bg: 'bg-gradient-to-br from-blue-500 to-blue-600',
          hover: 'hover:from-blue-600 hover:to-blue-700',
          shadow: 'shadow-blue-200',
        };
      case 'green':
        return {
          bg: 'bg-gradient-to-br from-green-500 to-green-600',
          hover: 'hover:from-green-600 hover:to-green-700',
          shadow: 'shadow-green-200',
        };
      case 'purple':
        return {
          bg: 'bg-gradient-to-br from-violet-500 to-violet-600',
          hover: 'hover:from-violet-600 hover:to-violet-700',
          shadow: 'shadow-violet-200',
        };
      default:
        return {
          bg: 'bg-gradient-to-br from-gray-500 to-gray-600',
          hover: 'hover:from-gray-600 hover:to-gray-700',
          shadow: 'shadow-gray-200',
        };
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {actions.map((action) => {
          const Icon = action.icon;
          const colors = getColorClasses(action.color);
          return (
            <Link
              key={action.name}
              to={action.to}
              className={`block ${colors.bg} ${colors.hover} rounded-xl p-8 hover:shadow-lg ${colors.shadow} transition-all group transform hover:scale-105`}
            >
              <div className="flex flex-col items-center text-center gap-4">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                  <Icon className="w-9 h-9 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-white text-lg mb-1">
                    {action.name}
                  </h3>
                  <p className="text-sm text-white/90">{action.description}</p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
